import { GridStore } from 'controls/grid/gridStore';
import { RuleDefinition, RulesConfiguration } from 'controls/queryBuilder/ruleDefinition';
import { ApiRequest, PagedList } from 'framework/api';
import { GridDataItem } from 'controls/grid/gridDataItem';
import { DashboardsListEntry } from './types';
import { serialize } from 'serializr';
import { Dashboard } from '../api';
import { GridSelection } from 'controls/grid/gridSelection';

export function getDashboardsListFilters() {
	return new ApiRequest<RulesConfiguration>({
		url: 'dashboards/summaryList/ruleConfiguration',
		accountBased: true,
		subaccountsFilter: true,
		method: 'GET',
	});
}

export function deleteDashboards(store: GridStore<DashboardsListEntry>) {
	return store.getSelectionApiRequest<DashboardsListEntry[]>({
		url: 'dashboards/summaryList/delete',
	});
}

export function exportCSV(store: GridStore<DashboardsListEntry>) {
	return store.getSelectionApiRequest<string>({
		url: 'dashboards/summaryList/exportCSV',
		preserveSort: true,
	});
}

export function setTags(
	store: GridStore<DashboardsListEntry>,
	selection: GridSelection<DashboardsListEntry>,
	tags: string[],
) {
	return store.getSelectionApiRequest({
		url: 'dashboards/summaryList/tags',
		payload: {
			bulkTags: tags,
		},
		selection,
	});
}

export function setPublic(store: GridStore<DashboardsListEntry>, isPublic: boolean) {
	return store.getSelectionApiRequest({
		url: `dashboards/summaryList/setPublic/${isPublic}`,
	});
}

export interface GetDashboardsArgs {
	accountId?: string;
	includeSubaccounts?: boolean;
}

export function getDashboards(args?: GetDashboardsArgs) {
	return new ApiRequest<PagedList<GridDataItem<DashboardsListEntry>>>({
		url: 'dashboards/summaryList',
		accountBased: true,
		accountId: args?.accountId,
		subaccountsFilter: true,
		includeSubaccounts: args?.includeSubaccounts,
		method: 'POST',
	});
}

export type GetDashboardsWithTheSameNameArgs = {
	name: string;
	accountId: string;
};

export function getDashboardsWithTheSameName(args: GetDashboardsWithTheSameNameArgs) {
	const group = RuleDefinition.fieldEqualRule('tag', args.name);

	const filterObj = {
		filter: serialize(group),
	};

	return new ApiRequest<PagedList<DashboardsListEntry>>({
		url: 'dashboards/summaryList',
		accountBased: true,
		accountId: args.accountId,
		includeSubaccounts: false,
		method: 'POST',
		payload: filterObj,
	});
}

export function getDashboard(id: string) {
	return new ApiRequest<Dashboard>({
		url: `dashboards/${id}`,
	});
}

export function saveDashboard(dashboard: DashboardsListEntry) {
	return new ApiRequest<DashboardsListEntry>({
		url: `dashboards`,
		method: 'POST',
		payload: dashboard,
		accountId: dashboard.accountId,
		accountBased: true,
	});
}

export function copyDashboardImages(imageIds: string[], accountId: string, targetAccountId: string) {
	return new ApiRequest<Record<string, string>>({
		url: 'dashboards/copy-images',
		method: 'POST',
		accountBased: true,
		accountId,
		payload: {
			imageIds,
			targetAccountId,
		},
	});
}
